import React, { useEffect, useState } from "react";
import "./grammarResponse.css";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AccordionResponse from "./AccordionResponse";
import constants from "../../constants/Grammar/responseGrammar.js";
import { useUser } from "../../context/userContext";
import { useGrammar } from "../../context/grammarContext";
import DataService from "services/DataService";
import { Button, FormControl, Input, FormHelperText } from "@material-ui/core";
import Loading from "components/Loading/loading";
import Cfg from "components/CFG/Cfg";
import ChomskyAndGreibachAccordion from "./ChomskyAndGreibachAccordion.jsx";
import { useAlert } from "context/Feedback/alertContext";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";
import { useSystem } from "context/systemContext";
import SystemOff from "views/System/SystemOff";
// import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 90,
    width: 120,
  },
  control: {
    padding: theme.spacing(2),
  },
  heading: {
    color: "white",
  },
}));

export default function GrammarResponse() {
  const classes = useStyles();
  const DEFAULT_INPUT_LIMIT = 100;

  // const inputStyles = styles();

  //   const [expanded, setExpanded] = React.useState(false);
  const [spacing] = React.useState(2);
  const { language, credential, isAdmin } = useUser();
  const { setIsAlive, isAlive } = useSystem();
  const [isLoading, setIsLoading] = useState(false);
  const {
    originalGrammar,
    setOriginalGrammar,
    responseOriginalGrammar,
    setOpenByClickCYK,
    setOpenByClickLeftMost,
    setOpenByClickAmbiguity,
  } = useGrammar();
  const [nonTerminals, setNonTerminals] = useState("");
  const [alphabet, setAlphabet] = useState("");
  const [rules, setRules] = useState("");
  const [initialVariable, setInitialVariable] = useState("");
  const [CYKword, setCYKword] = useState("");
  const [wordLeftMost, setWordLeftMost] = useState("");
  const [ambiguityWord, setAmbiguityWord] = useState("");
  const [open, setOpen] = useState(false);
  const { setAlert } = useAlert();
  const [cykError, setCykError] = useState("");
  const [leftMostError, setLeftMostError] = useState("");
  const [ambiguityError, setAmbiguityError] = useState("");

  let history = useHistory();
  window.addEventListener("load", () => {
    window.location.href = "/user/grammar";
  });

  useEffect(() => {
    DataService.isAlive({
      headers: {
        Authorization: credential,
      },
    })
      .then((res) => {
        setIsAlive(res.data);
      })
      .catch((e) => {
        alert(e);
      });
  }, []);

  useEffect(() => {
    if (Object.keys(responseOriginalGrammar).length) {
      let vetV = "{";
      let count = 0;
      for (let elem of responseOriginalGrammar[1]) {
        count++;
        vetV += elem;
        if (count < responseOriginalGrammar[1].length) {
          vetV += ", ";
        }
      }
      vetV += "}";
      let html = (
        <div>
          <span className="variables">{vetV}</span>
        </div>
      );
      setNonTerminals(html);

      count = 0;
      let vetE = "{";
      for (let elem of responseOriginalGrammar[2]) {
        count++;
        vetE += elem;
        if (count < responseOriginalGrammar[2].length) {
          vetE += ", ";
        }
      }
      vetE += "}";
      html = (
        <div>
          <span className="variables">{vetE}</span>
        </div>
      );
      setAlphabet(html);

      let vetP = "{";
      count = 0;
      let count1 = 0;
      for (let elem of responseOriginalGrammar[3]) {
        vetP += elem;
        count++;
        count1++;
        if (count < responseOriginalGrammar[3].length) {
          vetP += ", ";
          if (count1 === 3) {
            count1 = 0;
            vetP += "<br>";
          }
        }
      }
      vetP += "}";
      html = (
        <div
          className="container-variables"
          dangerouslySetInnerHTML={{ __html: vetP }}
        ></div>
      );
      setRules(html);
      html = (
        <div className="container-variables">
          <span className="variables">{responseOriginalGrammar[0][0]}</span>
        </div>
      );
      setInitialVariable(html);
    } else {
      if (!originalGrammar) {
        window.location.href = "/user/grammar";
      }
    }
  }, [responseOriginalGrammar]);

  const onRequestIdGrammar = async () => {
    let dados = {
      variables: originalGrammar,
    };
    const authorization = {
      headers: {
        Authorization: credential,
      },
    };
    try {
      const response = await DataService.createGrId(dados, authorization);
      return (
        // <div className="internal-gram">
        <div>
          <div dangerouslySetInnerHTML={{ __html: response.data[0] }} />
          <div className="popUpAccord">
            <div dangerouslySetInnerHTML={{ __html: response.data[1] }} />
          </div>
        </div>

        //  </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onSubmitNonContracting = async () => {
    let dados = {
      variables: originalGrammar,
    };
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      const response = await DataService.createNonContracting(
        dados,
        authorization
      );
      return (
        // <div className="internal-gram">
        <div>
          <div dangerouslySetInnerHTML={{ __html: response.data[1] }} />
          <div className="popUpAccord">
            <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
          </div>
        </div>
        // </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onSubmitNonRecursiveInitialSymbol = async () => {
    let dados = {
      variables: originalGrammar,
    };
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      const response = await DataService.createNonRecursiveInitial(
        dados,
        authorization
      );
      return (
        // <div className="internal-gram">
        <div>
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: response.data[1] }}
          />
          <div className="popUpAccord">
            <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
          </div>
          {/* </div> */}
        </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onSubmitNonCascade = async () => {
    let dados = {
      variables: originalGrammar,
    };
    const authorization = {
      headers: {
        Authorization: credential,
      },
    };
    try {
      const response = await DataService.createNonCascade(dados, authorization);
      return (
        // <div className="internal-gram">
        <div>
          <div
            style={{ paddingRight: "16px" }}
            dangerouslySetInnerHTML={{ __html: response.data[3] }}
          />
        </div>
        // </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onSubmitOnlyTerm = async () => {
    let dados = {
      variables: originalGrammar,
    };
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      const response = await DataService.createOnlyTerm(dados, authorization);
      return (
        // <div className="internal-gram">
        <div>
          <div className="popUpAccord">
            <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
          </div>
          {/* </div> */}
        </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onSubmitOnlyReach = async () => {
    let dados = {
      variables: originalGrammar,
    };
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      const response = await DataService.createOnlyReach(dados, authorization);
      return (
        // <div className="internal-gram">
        <div>
          <div className="popUpAccord">
            <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
          </div>
        </div>
        // </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onSubmitCYK = async () => {
    if (CYKword === "") {
      setAlert({
        active: true,
        text: `${constants.errors.missWord[language]}`,
        color: "danger",
        sevarity: "error",
      });
    } else {
      try {
        let dados = {
          word: CYKword,
          variables: originalGrammar,
        };

        const authorization = {
          headers: {
            Authorization: credential,
          },
        };
        const response = await DataService.createCYK(dados, authorization);
        return (
          // <div className="internal-gram">
          <div>
            <div>
              <div dangerouslySetInnerHTML={{ __html: response.data[0] }} />
              <br />
            </div>
            <div dangerouslySetInnerHTML={{ __html: response.data[1] }} />
          </div>
          //  </div>
        );
      } catch (e) {
        alert(e);
      }
    }
  };

  const onSubmitLeftMostDerivation = async () => {
    if (wordLeftMost === "") {
      setAlert({
        active: true,
        text: `${constants.errors.missWord[language]}`,
        color: "danger",
        sevarity: "error",
      });
    } else {
      let dados = {
        word: wordLeftMost,
        variables: originalGrammar,
      };
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      try {
        const response = await DataService.createLeftMostDerivation(
          dados,
          authorization
        );
        return (
          // <div className="internal-gram">
          <div>
            <div>
              <br />
              <div dangerouslySetInnerHTML={{ __html: response.data[0] }} />
            </div>
            <div style={{ textAlign: "left" }}>
              <div
                dangerouslySetInnerHTML={{ __html: response.data[1] }}
              />{" "}
            </div>
          </div>
          //  </div>
        );
      } catch (e) {
        alert(e);
      }
    }
  };

  const onSubmitCreateCheckAmbiguity = async () => {
    // if (component.state.charge) {
    let valueTemp = ambiguityWord;
    if (ambiguityWord === "") {
      valueTemp = null;
    }
    const authorization = {
      headers: {
        Authorization: credential,
      },
    };
    let dados = {
      word: valueTemp,
      variables: originalGrammar,
    };
    try {
      setIsLoading(true);
      const response = await DataService.createCheckAmbiguity(
        dados,
        authorization
      );
      if (response.data[0] === "Cancelando busca") {
        setIsLoading(false);
      }

      let valueAmb = response.data[1].split(".");

      if (valueAmb[1] === "") {
        setIsLoading(false);
        return (
          // <div className="internal-gram">
          <div>
            <div>
              <br />
              <div
                dangerouslySetInnerHTML={{
                  __html: constants.accordion.response.ambiguity[language],
                }}
              />
            </div>
            <div
              style={{ textAlign: "left" }}
              dangerouslySetInnerHTML={{ __html: response.data[1] }}
            />
          </div>
          // </div>
        );
      } else {
        setIsLoading(false);
        return (
          <div>
            <div>
              <br />
              <div dangerouslySetInnerHTML={{ __html: valueAmb[0] }} />
            </div>
            <div
              style={{ textAlign: "left" }}
              dangerouslySetInnerHTML={{ __html: valueAmb[1] }}
            />
          </div>
        );
      }
    } catch (e) {
      alert(e);
    }

    // } else component.setState({ charge: !component.state.charge });
  };

  const onSubmitImmedLeftRecursion = async () => {
    let dados = {
      variables: originalGrammar,
    };
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      const response =
        await DataService.createRemovingTheImmediateLeftRecursion(
          dados,
          authorization
        );
      return (
        // <div className="internal-gram">
        <div>
          <div dangerouslySetInnerHTML={{ __html: response.data[1] }} />
          <div className="popUpAccord">
            <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
          </div>
        </div>
        // </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onRemovalDirLeftRec = async () => {
    let dados = {
      variables: originalGrammar,
    };
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      const response = await DataService.createRemovalDirLeftRec(
        dados,
        authorization
      );
      return (
        // <div className="internal-gram">
        <div>
          <div dangerouslySetInnerHTML={{ __html: response.data[1] }} />
          <div className="popUpAccord RemDirLeftRec">
            <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
          </div>
        </div>
        // </div>
      );
    } catch (e) {
      alert(e);
    }
  };

  const onSubmitCfgToPda = async () => {
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      let dados = {
        variables: originalGrammar,
      };
      const response = await DataService.CfgToPda(dados, authorization);
      if (response.data.length === 1) {
        return (
          <div>
            <div style={{ textAlign: "left" }}>
              {/* Exibe o conteúdo HTML completo */}
              <div dangerouslySetInnerHTML={{ __html: response.data[0] }} />
            </div>
          </div>
        );
      } else if (response.data.length === 7) {
        let temp1 = response.data[4].split("\n");
        let temp2 = response.data[6].split("\n");
        let heightMult = 0;
        if (temp1.length > temp2.length && temp1.length > 6) {
          heightMult = temp1.length;
        } else if (temp2.length > temp1.length && temp2.length > 6) {
          heightMult = temp2.length;
        }
        return (
          // <div className="internal-gram">
          <div>
            <div style={{ textAlign: "left" }}>
              <Cfg
                heigth={heightMult}
                sText={response.data[4]}
                finalText={response.data[6]}
                oneState={false}
              />
              <br />
            </div>
            <div style={{ textAlign: "left" }}>
              <div dangerouslySetInnerHTML={{ __html: response.data[1] }} />
              <div dangerouslySetInnerHTML={{ __html: response.data[2] }} />
              <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
              <div dangerouslySetInnerHTML={{ __html: response.data[5] }} />
            </div>
          </div>
          //  </div>
        );
      } else {
        let temp1 = response.data[4].split("\n");
        let heightMult = temp1.length > 6 ? temp1.length : 0;
        return (
          // <div className="internal-gram">
          <div>
            <div style={{ textAlign: "left" }}>
              <Cfg
                heigth={heightMult}
                sText={response.data[4]}
                oneState={true}
              />
              <br />
            </div>
            <div style={{ textAlign: "left" }}>
              <div dangerouslySetInnerHTML={{ __html: response.data[1] }} />
              <div dangerouslySetInnerHTML={{ __html: response.data[2] }} />
              <div dangerouslySetInnerHTML={{ __html: response.data[3] }} />
            </div>
          </div>
          // </div>
        );
      }
    } catch (e) {
      setAlert({
        active: true,
        text: constants.errors.pda[language],
        color: "danger",
        sevarity: "error",
      });
      return (
        <div>
          <div style={{ textAlign: "left" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: constants.accordion.response.impossiblePDA[language],
              }}
            />
          </div>
        </div>
      );
    }
  };

  const onSubmitChomsky = async () => {
    let dados = {
      variables: originalGrammar,
    };
    const authorization = {
      headers: {
        Authorization: credential,
      },
    };
    try {
      const response = await DataService.createChomsky(dados, authorization);
      let vetTemp = response.data[0].split("*++*");
      const object = {
        varChomSkyNRIS: (
          <div>
            <div dangerouslySetInnerHTML={{ __html: vetTemp[0] }} />
          </div>
        ),
        lSolutionCompleteChsNRIS: (
          <div className="popUpAccord">
            <div dangerouslySetInnerHTML={{ __html: vetTemp[1] }} />
          </div>
        ),
      };
      vetTemp = response.data[1].split("*++*");
      object.varChomSkyENC = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: vetTemp[0] }} />
        </div>
      );
      object.lSolutionCompleteChsENC = (
        <div className="popUpAccord">
          <div dangerouslySetInnerHTML={{ __html: vetTemp[1] }} />
        </div>
      );
      vetTemp = response.data[2].split("*++*");
      object.varChomSkyNC = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: vetTemp[0] }} />
        </div>
      );
      object.lSolutionCompleteChsNC = (
        <div className="popUpAccord">
          <div dangerouslySetInnerHTML={{ __html: vetTemp[1] }} />
        </div>
      );
      vetTemp = response.data[3].split("*++*");
      object.varChomSkyOT = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: vetTemp[0] }} />
        </div>
      );
      object.lSolutionCompleteChsOT = (
        <div className="popUpAccord">
          <div dangerouslySetInnerHTML={{ __html: vetTemp[1] }} />
        </div>
      );
      vetTemp = response.data[4].split("*++*");
      object.varChomSkyOR = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: vetTemp[0] }} />
        </div>
      );
      object.lSolutionCompleteChsOR = (
        <div className="popUpAccord">
          <div dangerouslySetInnerHTML={{ __html: vetTemp[1] }} />
        </div>
      );
      vetTemp = response.data[5].split("*++*");
      object.varChomSky = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: vetTemp[0] }} />
        </div>
      );
      object.lSolutionCompleteChomSky = (
        <div className="popUpAccord">
          <div dangerouslySetInnerHTML={{ __html: vetTemp[1] }} />
        </div>
      );
      vetTemp = response.data[6].split("*++*");
      let elemSplit = vetTemp[0].split("<tr>");
      let qntEle = -1;
      let propStyle = { "": "" };
      for (let i = 1; i < elemSplit.length; ++i) {
        if (elemSplit[i].split("→")[1].split("|").length > qntEle) {
          qntEle = elemSplit[i].split("→")[1].split("|").length;
        }
      }

      if (qntEle > 19) {
        propStyle = { position: "relative", left: "1em" };
      }

      object.varChomFNG = (
        <div style={propStyle}>
          <div dangerouslySetInnerHTML={{ __html: vetTemp[0] }} />
        </div>
      );

      object.lSolutionCompleteChsFNG = (
        <div className="popUpAccord">
          <div dangerouslySetInnerHTML={{ __html: vetTemp[1] }} />
        </div>
      );
      return object;
    } catch (e) {
      alert(e);
    }
  };
  const goBack = () => {
    setOriginalGrammar(originalGrammar);
    history.goBack();
  };
  const changeInputValue = (el) => {
    if (el.value.length > DEFAULT_INPUT_LIMIT) {
      const msg = `${constants.errors.characterLimitMessage[language]}${DEFAULT_INPUT_LIMIT}`;
      if (el.name === "cyk") {
        setCykError(msg);
      } else if (el.name === "wordLeftMost") {
        setLeftMostError(msg);
      } else if (el.name === "ambiguity") {
        setAmbiguityError(msg);
      }
      return;
    }
    if (el.name == "cyk") {
      setCYKword(el.value);
      setCykError("");
      let bt = document.getElementById("bt-cyk");
      if (el.value.length > 0) {
        bt.classList.remove("input-button-disabled");
        bt.classList.add("input-button-success");
      } else {
        bt.classList.remove("input-button-success");
        bt.classList.add("input-button-disabled");
      }
    } else if (el.name == "wordLeftMost") {
      setWordLeftMost(el.value);
      setLeftMostError("");
      let bt = document.getElementById("bt-wordLeftMost");
      if (el.value.length > 0) {
        bt.classList.remove("input-button-disabled");
        bt.classList.add("input-button-success");
      } else {
        bt.classList.remove("input-button-success");
        bt.classList.add("input-button-disabled");
      }
    } else if (el.name == "ambiguity") {
      setAmbiguityWord(el.value);
      setAmbiguityError("");
      let bt = document.getElementById("bt-ambiguity");
      if (el.value.length > 0) {
        bt.classList.remove("input-button-disabled");
        bt.classList.add("input-button-success");
      } else {
        bt.classList.remove("input-button-success");
        bt.classList.add("input-button-disabled");
      }
    }
  };

  // const teste = () => {
  //   setOpen(true);
  // };

  const openFunction = () => {
    setOpen(!open);
  };
  if (!isAlive && !isAdmin) {
    // location.reload();
    return <SystemOff />;
  }

  return (
    <div className="container-response" id="tt">
      {/* <h1>back</h1> */}
      <div className="div-icon-back">
        <ArrowBackIcon
          onClick={() => {
            goBack();
          }}
          className="icon"
          fontSize="large"
        />
      </div>
      <div className="wrapper-symbols">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent="center"
            spacing={spacing}
            direction="row"
          >
            <Grid
              lg={2}
              xs={1}
              style={{ display: "flex", justifyItems: "center" }}
              item
            >
              <div className="G">
                <div className="item G item-nomargin"></div>
              </div>
            </Grid>
            <Grid
              item
              xs={2}
              lg={2}
              style={{ display: "flex", justifyItems: "center" }}
            >
              <div className={classes.paper}>
                <div className="item V item-nomargin">{nonTerminals}</div>
              </div>
            </Grid>
            <Grid
              lg={2}
              xs={2}
              style={{ display: "flex", justifyItems: "center" }}
              item
            >
              <div className={classes.paper}>
                <div className="item E item-nomargin">{alphabet}</div>
              </div>
            </Grid>
            <Grid
              lg={3}
              xs={3}
              style={{ display: "flex", justifyItems: "center" }}
              item
            >
              <div>
                <div className="item P item-nomargin">{rules}</div>
              </div>
            </Grid>
            <Grid
              lg={1}
              xs={1}
              style={{ display: "flex", justifyItems: "center" }}
              item
            >
              <div className={classes.paper}>
                <div className="item S item-nomargin">{initialVariable}</div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <br />

      <br />
      <div className="wrapper-accordion">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent="center"
            spacing={spacing}
            direction="row"
          >
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onRequestIdGrammar}
                title={constants.accordion.header.identification[language]}
                panel="IdGrammar"
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitNonRecursiveInitialSymbol}
                title={constants.accordion.header.nonRecursive[language]}
                panel="NonRecursive"
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitNonContracting}
                title={constants.accordion.header.nonContractive[language]}
                panel="NonContracting"
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div className="wrapper-accordion">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent="center"
            spacing={spacing}
            direction="row"
          >
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitNonCascade}
                title={constants.accordion.header.noChainRules[language]}
                panel="NonCascade"
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitOnlyTerm}
                title={constants.accordion.header.onlyTerminals[language]}
                panel="OnlyTerm"
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitOnlyReach}
                title={constants.accordion.header.onlyReachable[language]}
                panel="OnlyReach"
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div className="wrapper-accordion">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent="center"
            spacing={spacing}
            direction="row"
          >
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitCYK}
                title={constants.accordion.header.cyk}
                panel="CYK"
                functionOpen={openFunction}
              />
              <div style={{ display: "flex", flexDirection: "row" }}>
                <FormControl className="form-input" variant="standard">
                  <Input
                    className="input"
                    placeholder={constants.accordion.input.Inputword[language]}
                    value={CYKword}
                    name="cyk"
                    id="cyk-word-input"
                    autoComplete="off"
                    onChange={(el) => {
                      changeInputValue(el.target);
                    }}
                    inputProps={{ maxLength: DEFAULT_INPUT_LIMIT + 1 }}
                    error={!!cykError}
                  />
                  {cykError && (
                    <FormHelperText error>{cykError}</FormHelperText>
                  )}
                </FormControl>
                <Button
                  id="bt-cyk"
                  className="input-button-disabled"
                  onClick={() => {
                    setOpenByClickCYK(true);
                  }}
                >
                  {constants.accordion.buttonSubmit[language]}
                </Button>
                {/* </div> */}
              </div>
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitLeftMostDerivation}
                title={constants.accordion.header.leftMostDerivation[language]}
                panel="LeftMost"
              />
              <div style={{ display: "flex", flexDirection: "row" }}>
                <FormControl className="form-input" variant="standard">
                  <Input
                    className="input"
                    name="wordLeftMost"
                    id="left-most-word-input"
                    placeholder={constants.accordion.input.Inputword[language]}
                    autoComplete="off"
                    onChange={(el) => {
                      changeInputValue(el.target);
                    }}
                    value={wordLeftMost}
                    inputProps={{ maxLength: DEFAULT_INPUT_LIMIT + 1 }}
                    error={!!leftMostError}
                  />
                  {leftMostError && (
                    <FormHelperText error>{leftMostError}</FormHelperText>
                  )}
                </FormControl>
                <Button
                  id="bt-wordLeftMost"
                  className="input-button-disabled"
                  onClick={() => {
                    setOpenByClickLeftMost(true);
                  }}
                >
                  {constants.accordion.buttonSubmit[language]}
                </Button>
              </div>
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitCreateCheckAmbiguity}
                title={constants.accordion.header.ambiguity[language]}
                panel="Ambiguity"
              >
                <Loading open={isLoading} />
              </AccordionResponse>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <FormControl className="form-input" variant="standard">
                  <Input
                    className="input"
                    name="ambiguity"
                    id="ambiguity-word-input"
                    placeholder={constants.accordion.input.word[language]}
                    autoComplete="off"
                    onChange={(el) => {
                      changeInputValue(el.target);
                    }}
                    value={ambiguityWord}
                    inputProps={{ maxLength: DEFAULT_INPUT_LIMIT + 1 }}
                    error={!!ambiguityError}
                  />
                  {ambiguityError && (
                    <FormHelperText error>{ambiguityError}</FormHelperText>
                  )}
                </FormControl>
                <Button
                  id="bt-ambiguity"
                  className="input-button-disabled"
                  onClick={() => {
                    setOpenByClickAmbiguity(true);
                  }}
                >
                  {constants.accordion.buttonSubmit[language]}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div className="wrapper-accordion">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent="center"
            spacing={spacing}
            direction="row"
          >
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitImmedLeftRecursion}
                title={constants.accordion.header.directLeftRecursion[language]}
                panel="LeftRecursion"
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onRemovalDirLeftRec}
                title={
                  constants.accordion.header.indirectLeftRecursion[language]
                }
                panel="DirLeftRecursion"
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <AccordionResponse
                color="#e9eaea"
                function={onSubmitCfgToPda}
                title={constants.accordion.header.CFGtoPushdown[language]}
                panel="CFGtoPDA"
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div className="wrapper-accordion">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent="center"
            spacing={spacing}
            direction="row"
          >
            <Grid item lg={12} xs={12}>
              <ChomskyAndGreibachAccordion function={onSubmitChomsky} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
